import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

import { useMultichoiceCreatorContext } from 'hooks/useContext';
import services from 'api/services';

const { TestService } = services;

export const useDeleteQuestionOptionAndParagraph = () => {
  const navigate = useNavigate();

  const { setQuestion, setOptions, setParagraphs, setParagraph } = useMultichoiceCreatorContext();

  const [deleting, setDeleting] = useState(false);

  const deleteQuestionOptionAndParagraph = async (testId, id, type) => {
    try {
      if (deleting) return toast.error('Already saving');
      setDeleting(true);

      if (type === 'option') {
        const response = await TestService.deleteOption(id);
        setOptions((options) => options.filter((option) => option._id !== response._id));
        toast.success('Option deleted successfully');
      } else if (type === 'question') {
        await TestService.deleteQuestion(id);
        toast.success('Question deleted successfully');
        navigate(`/multichoice-creator/${testId}`);
      } else if (type === 'paragraph') {
        const paragraph = await TestService.removeParagraph(id);
        if (paragraph?.archived) setParagraphs((paragraphs) => paragraphs.filter((p) => p._id !== paragraph._id));
        setParagraph({});
        setQuestion((question) => ({ ...question, paragraph: null }));
        toast.success('Paragraph removed successfully');
      }
    } catch (error) {
      toast.error(error.message ?? error ?? `Error deleting ${type}`);
    } finally {
      setDeleting(false);
    }
  };

  return [deleting, deleteQuestionOptionAndParagraph];
};
